import { getCall, postCall, downloadCall } from "./api";

/**
 * Offer, relieving and full-and-final letters.
 *
 * The PDF is built on the server in memory and never stored — what persists is
 * a record of what it was made from, so a re-download regenerates the same
 * document rather than fetching a file. That is why `redownload` takes a
 * letter id and not a URL.
 */

// What the letter would say, and what is missing that would improve it.
// Safe to call repeatedly: it issues nothing and records nothing.
export const previewLetter = async (employeeId, type) =>
  await getCall({ path: `/letter/employee/${employeeId}/${type}/preview` });

// Issue it. Without `email` it comes back as a PDF to download; with it, the
// server sends it to the employee and returns a receipt instead.
export const issueLetter = async (employeeId, type) =>
  await downloadCall({ path: `/letter/employee/${employeeId}/${type}`, method: "POST" });

export const emailLetter = async (employeeId, type) =>
  await postCall({ path: `/letter/employee/${employeeId}/${type}?email=true` });

export const getLetterHistory = async (employeeId) =>
  await getCall({ path: `/letter/employee/${employeeId}/history` });

export const redownloadLetter = async (letterId) =>
  await downloadCall({ path: `/letter/issued/${letterId}` });
